module.exports = __webpack_public_path__ + "static/media/ar21_pnolan.4c905611.jpeg";